import { numberChartService } from "./number-chart.service";
import { Validators } from "@angular/forms";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import * as moment from "moment";
import { min } from "d3";
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

// moment.locale("es");

@Component({
  selector: "app-number-chart",
  templateUrl: "./number-chart.component.html",
  styleUrls: ["./number-chart.component.scss"],
})
export class numberChartComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private numberChartService: numberChartService,public spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}
  @Input() listColumn = [];
  @Input() queryId: string;
  @Input() basedOnId: string;
  @Input() queryConfigType: string;
  @Input() selectTypeGraphic;
  @Input() arguments = [];
  @Input() selectTypeGrafico: string;
  @Output() onVewGraphic: EventEmitter<any> = new EventEmitter<any>();
  registernumberForm: FormGroup;
  controls: any;
  vValues = false;
  oValues = false;
  submitted = false;
  dataGraphic: any = {};
  objectGraphic: any = {};
  msgSpiner = 'Cargando...';

  message = {
    message: null,
    class: null,
  };
  newObject = {
    number: 34,
    title: "asd",
    background: ''
  };

  ngOnInit() {
    this.registernumberForm = this.formBuilder.group({
      value: [null, [Validators.required]],
      title: ['Titulo de ejemplo', [Validators.required]],
      color: ["transparent", [Validators.required]],
    });
    this.controls = this.registernumberForm.controls;
  }

  showGraphic() {
    this.spinner.show()
    this.submitted = true;
    console.log(this.controls);

    if (this.registernumberForm.invalid) {
      this.message = {
        message: "Todos los campos son obligatorios",
        class: "alert alert-danger mt-2",
      };
      setTimeout(() => {
        this.message = {
          message: null,
          class: null,
        };
      }, 3000);
      return;
    }
    this.newObject.title = this.registernumberForm.controls.title.value;
     this.newObject.background = this.registernumberForm.controls.color.value;
    // this.newObject.title.text = this.registernumberForm.controls.title.value;
    // this.newObject.chart.toolbar.export.png.filename =
    //   this.newObject.title.text +
    //   "-" +
    //   moment().format("MMMM Do YYYY, h:mm:ss a");
    // this.newObject.chart.toolbar.export.svg.filename =
    //   this.newObject.title.text +
    //   "-" +
    //   moment().format("MMMM Do YYYY, h:mm:ss a");
    // this.newObject.chart.toolbar.export.csv.filename =
    //   this.newObject.title.text +
    //   "-" +
    //   moment().format("MMMM Do YYYY, h:mm:ss a");
    
    console.log('queryID',this.queryId);
    console.log("arguments",this.arguments);   
    console.log('based',this.basedOnId)
    console.log('queryconfig',this.queryConfigType);
    //Peticion del grafico
    this.spinner.show()
    this.numberChartService
      .onGetDataGraphic(
        this.queryId,
        this.basedOnId,
        this.arguments,
        this.queryConfigType
      )
      .subscribe((res: any) => {
        this.objectGraphic = this.getDataGrafic(res);
        // this.newObject.series = this.objectGraphic;
        // this.newObject.series = this.newObject.series;
        //Se emitirá al componente contenedor el objeto grafico, para posteriormente visializarlo
        this.onVewGraphic.emit(this.newObject);
        
      }, err => {
        this.toastr.error('Error consulta de datos del grafico Area: ' +  err);
        this.spinner.hide();
        console.log('Error consulta de dtos del grafico Area: ', err);
      });
      this.spinner.hide();
  }

  getDataGrafic(resp){
    let ListDataGrid = resp.data;
    console.log('number asd',ListDataGrid)

    ListDataGrid.forEach(element => {
      // console.log(element.C);
      this.newObject.number = element[this.registernumberForm.controls.value.value.field];

    });
    
  }
}
